/// <amd-module name="VSS/Features/Markdown/MarkdownConstants" />
export class MarkdownConstants {
    public static TOCDefaultMarker = "[[_TOC_]]";
    public static NoTOCDefaultMarker = "[[_NOTOC_]]";
    public static TOCDefaultMarkerPattern = /^\[\[_TOC_\]\][\s]*$/m;
    public static TOSPDefaultMarker = "[[_TOSP_]]";
    public static MaskedTokenType = "container_token";
    public static MarkDownLinesMappingAttrName = "mlp";
}
